import React from 'react';
import { Step } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

function StepsWrapper(props) {
  const { t, currentStep, setCurrentStep, steps } = props;

  return (
    <Step.Group size="mini" unstackable widths={steps.length}>
      {steps.map((step, index) => {
        const stepIndex = index + 1;
        return (
          <Step
            active={currentStep == stepIndex}
            onClick={() => setCurrentStep(stepIndex)}
            completed={currentStep > stepIndex}
            disabled={currentStep !== stepIndex && step.disabled}
            title={t(step.title)}
            description={t(step.description)}
            icon={step.iconComponent}
            key={`step${stepIndex}`}
          ></Step>
        );
      })}
    </Step.Group>
  );
}

StepsWrapper.propTypes = {
  currentStep: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  steps: PropTypes.array.isRequired
};

export default React.memo(withTranslation()(StepsWrapper));
